import Cookies from 'js-cookie';

import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useLeadChannelStore from '../leadChannelStore/useLeadChannelStore';
import { ensureVendorScript } from '../trackingPixelStore/functions/ensureVendorScript';
import { cookieStore } from './cookieStore';
import { releaseConsentManager } from './plugins/consentManagerPlugin';

const useCookieStore = createStore({
  creator: cookieStore({
    Cookies,
    ensureVendorScript,
    releaseConsentManager,
    useLeadChannelStore: lazyDependency(() => useLeadChannelStore),
  }),
  id: 'cookie',
  // the consent manager loads once per page load, so a sign-out mustn't make it loadable again
  ignoreReset: true,
  middlewares: {
    devtools: true,
  },
});

export default useCookieStore;
